import { mainSiteUrl } from '@/mocks/categories';
import { homeContent } from '@/mocks/content';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20composition%20with%20carefully%20arranged%20fashion%20accessories%20leather%20goods%20sunglasses%20scarves%20and%20small%20decorative%20objects%20on%20light%20cream%20textured%20surface%20overhead%20view%20soft%20diffused%20natural%20light%20gentle%20shadows%20editorial%20aesthetic%20warm%20neutral%20tones%20no%20people%20no%20text&width=1600&height=900&seq=hero-bg-v2-unique&orientation=landscape"
          alt="YOYBUY products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/30 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-foreground-950 leading-[1.05] mb-6">
              {homeContent.heroTitle}
            </h1>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-8">
              {homeContent.heroSubtitle}
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
              >
                {homeContent.heroCta1}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-background-50 text-sm md:text-base font-semibold hover:bg-accent-600 transition-all hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
              >
                {homeContent.heroCta2}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shopping-bag-line"></i>
                </span>
              </a>
            </div>
          </div>

          <div className="flex-1 hidden lg:block">
            <div className="relative">
              <div className="w-full aspect-[4/3] rounded-3xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20flat%20lay%20arrangement%20of%20folded%20knitwear%20sweaters%20soft%20linen%20scarves%20and%20minimalist%20jewelry%20pieces%20on%20warm%20beige%20linen%20surface%20natural%20morning%20sunlight%20streaming%20through%20sheer%20curtains%20editorial%20product%20photography%20calm%20neutral%20aesthetic&width=800&height=600&seq=hero-side-v2-unique&orientation=landscape"
                  alt="YOYBUY fashion items"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-48 md:w-56 aspect-square rounded-3xl overflow-hidden border-4 border-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=Closeup%20product%20shot%20of%20a%20premium%20canvas%20backpack%20with%20leather%20details%20resting%20on%20light%20oak%20surface%20with%20a%20small%20potted%20plant%20soft%20natural%20window%20light%20warm%20neutral%20palette%20editorial%20aesthetic%20clean%20composition&width=400&height=400&seq=hero-badge-v2-unique&orientation=squarish"
                  alt="Featured backpack"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}